import { Divider, Stack, DialogContent, DialogActions, Dialog, MenuItem, Box } from '@mui/material';
import { UseFormReturn, useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { FormProvider, RHFDatePicker, RHFSelect, RHFTextField } from '@app/components';
import { IOfferLetter } from '../../type';
import { addOfferLetterSchema } from '../../validators';
import { addOfferLetter } from '../../slice';
import { selectAddOfferLetterState } from '../../selectors';
import { useRequestState } from '@app/hooks';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  methods: UseFormReturn<IOfferLetter>;
}

const OfferLetterDetailDialog = ({ open, onClose, methods }: Props) => {
  methods = useForm<IOfferLetter>({
    resolver: yupResolver(addOfferLetterSchema) as any,
    defaultValues: {
      fullName: '',
      joiningDate: '',
      monthlySalary: '',
      position: '',
      contraction: '',
    },
  });
  const dispatch = useDispatch();
  const onSubmit = (form: IOfferLetter) => {
    dispatch(addOfferLetter({ ...form }));
    console.log('form', form);
  };
  const { loading } = useRequestState({
    stateSelector: selectAddOfferLetterState,
    onSuccess: onClose,
    successMessageShown: true,
    errorShown: true,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <Dialog open={open}>
          <Header variant="dialog" title={Strings.dialogHeading.addOfferLetter} onClose={onClose} />
          <Divider />
          <DialogContent>
            <Stack my={2} justifyContent={'space-between'} direction={'row'} spacing={2}>
              <RHFTextField
                required
                name="fullName"
                label={Strings.field.name}
                fullWidth
                variant="outlined"
                sx={{ flex: 1 }}
              />
              <RHFDatePicker name="joiningDate" label={Strings.field.date} sx={{ flex: 1 }} />
            </Stack>
            <Stack my={2} justifyContent={'space-between'} direction={'row'} spacing={2}>
              <RHFTextField
                required
                name="monthlySalary"
                label={Strings.field.monthlySalary}
                variant="outlined"
              />
              <RHFTextField required label={Strings.field.position} name="position" fullWidth />
            </Stack>

            <RHFSelect required label={Strings.field.contraction} name="contraction" fullWidth>
              <MenuItem value="Mr">Mr</MenuItem>
              <MenuItem value="Ms">Ms</MenuItem>
            </RHFSelect>

            <Box my={2} />

            <RHFTextField
              multiline
              minRows={2}
              label={Strings.field.address}
              name="address"
              fullWidth
            />
          </DialogContent>
          <Divider sx={{ pt: 2 }} />
          <DialogActions>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              loading={loading}
              onClick={methods.handleSubmit(onSubmit)}
            >
              {Strings.button.submit}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default OfferLetterDetailDialog;
